import { LoginFormPanel } from "./LoginFormPanel";
import { LoginMarketingPanel } from "./LoginMarketingPanel";

/**
 * Página de login · split 50/50 en desktop (marketing izq + form der) y
 * full-width en mobile (solo form, con header de branding embebido).
 *
 * El gating ("si ya hay sesión → /dashboard") vive en el `beforeLoad` del
 * route file, no aquí. Acá solo es presentación.
 */
export function LoginPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="grid min-h-screen overflow-hidden md:grid-cols-2">
        <LoginMarketingPanel />
        <LoginFormPanel />
      </div>
    </div>
  );
}
